module.exports = __webpack_public_path__ + "static/media/innovative_teaching_learning_OFC_CASESTUDY.c6f04b12.pdf";